import type { ReactNode } from 'react';
import { t } from '@/i18n';
import styles from './StatsRow.module.css';

const statsFooter: { big: ReactNode; small: string }[] = [
  { big: t.home.stats.spreadsDoneValue, small: t.home.stats.spreadsDone },
  {
    big: (
      <>
        {t.home.stats.avgRatingValue}{' '}
        <span className={styles.starInBig} aria-hidden>
          {String.fromCodePoint(0x2605)}
        </span>
      </>
    ),
    small: t.home.stats.avgRating,
  },
  { big: t.home.stats.avgResponseTimeValue, small: t.home.stats.avgResponseTime },
];

export function StatsRow() {
  return (
    <div className={styles.footerRow}>
      {statsFooter.map((s) => (
        <div key={s.small} className={styles.footerCell}>
          <div className={styles.footerBig}>{s.big}</div>
          <div className={styles.footerSmall}>{s.small}</div>
        </div>
      ))}
    </div>
  );
}
